//#region import
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { ApiLeave } from 'enum/api';
import { FnAxios, FnDialog, I18n, } from "utilities/utilities";
import CardFrom from 'components/CardContent/CardFrom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import PersonIcon from '@mui/icons-material/Person';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { LeaveContext } from '../LeaveFrom';
import { EnumLeavePosition } from 'enum/enum';
//#endregion

const StepFlow = () => {
    const { 
        Objform,
        nLeaveID,
        nUserID,
        sUser,
        ObjApprover,
        // isNotApprovePart, //(True มี | False ไม่มี)
        // isPart,
        // arrUserApprove_1,
        // isPile,
        // arrUserApprove_2,
    } = useContext(LeaveContext);

    const [sApprove_1, setsApprove_1] = useState(null);
    const [sApprove_2, setsApprove_2] = useState(null);

    // useEffect(() => {
    //     console.log("Objform", Objform);        
    // }, [Objform]);

    useEffect(() => {
        if (ObjApprover)
        {
            //ผอ.ส่วน
            if (!ObjApprover?.isPart) 
            {
                Objform?.setValue("nApproveID_1", (ObjApprover?.arrUserApprove_1 || []).length > 0 ? (ObjApprover?.arrUserApprove_1 || [])[0].value : null);
                setsApprove_1((ObjApprover?.arrUserApprove_1 || []).length > 0 ? (ObjApprover?.arrUserApprove_1 || [])[0].label : null);
            }
            //ผอ.กอง
            if (!ObjApprover?.isPile) 
            {
                Objform?.setValue("nApproveID_2", (ObjApprover?.arrUserApprove_2 || []).length > 0 ? (ObjApprover?.arrUserApprove_2 || [])[0].value : null);
                setsApprove_2((ObjApprover?.arrUserApprove_2 || []).length > 0 ? (ObjApprover?.arrUserApprove_2 || [])[0].label : null);
            }
        }
    }, [ObjApprover]);

    return (
        <Grid item container xs={12} md={12} spacing={2} style={{ paddingBottom: '1%', }}>
            <Grid item xs={12} md={12}>
                <Divider textAlign="left" variant='middle'>
                    <Grid item container spacing={1}>
                        <Grid item><Typography variant="h6">{`${I18n.SetText("Leave.sApprover")}`}</Typography></Grid>
                        {/* <Grid item><Typography variant="h6" color={'red'}> *</Typography></Grid> */}
                    </Grid>                    
                </Divider>
            </Grid>
            { ObjApprover != null &&
                <Grid item container xs={12} md={12} spacing={1} justifyItems={'center'} justifyContent={'center'}>
                    <Grid item xs={12} md={3}>
                        <CardFrom bgColor='#ffe6de' heightCard='222px'>
                            <Grid item xs={12} md={12} sx={{ textAlign: 'center' }}>
                                <AccountCircleIcon sx={{ fontSize: '90px', color: '#cb6f2c' }} />
                                <Grid item>
                                    <Typography gutterBottom variant="h6" component="div">{`${I18n.SetText("Leave.sEmployee")}`}</Typography>
                                    <Typography variant="body2" color="text.secondary" style={{marginTop: '6%',}}>{sUser}</Typography>
                                </Grid>
                            </Grid>
                        </CardFrom>
                    </Grid>
                    <Grid item sx={{ marginTop: '6%', }}><ArrowForwardIosIcon sx={{ fontSize: '70px', color: '#aaefff' }} /></Grid>
                    {ObjApprover?.isNotApprovePart &&
                        <Fragment>
                            <Grid item xs={12} md={3}>
                                <CardFrom bgColor='#ffe6de' heightCard='222px'>
                                    <Grid item xs={12} md={12} sx={{ textAlign: 'center' }}>
                                        <PermIdentityIcon sx={{ fontSize: '90px', color: '#cb6f2c' }} />
                                        <Grid item>
                                            {/* <Typography gutterBottom variant="h6" component="div">{ObjApprover?.nApproverD1_PositionID === EnumLeavePosition.ApproverDV ? `${I18n.SetText("Leave.sDirector_Part_DV")}` : `${I18n.SetText("Leave.sDirector_Part_VP")}` }</Typography> */}
                                            <Typography gutterBottom variant="h6" component="div">{`${I18n.SetText("Leave.sDirector_Part_DVVP")}`}</Typography>
                                            {ObjApprover?.isPart ?
                                                <SelectItem
                                                    id={"nApproveID_1"}
                                                    name={"nApproveID_1"}
                                                    label={`${I18n.SetText("Leave.sNameofApprover")}`}
                                                    placeholder={`${I18n.SetText("Leave.sDefaultApprover")}`}
                                                    options={ObjApprover?.arrUserApprove_1 ?? []}
                                                    required={true}
                                                />                         
                                                :
                                                <Typography variant="body2" color="text.secondary" style={{marginTop: '6%',}}>{sApprove_1}</Typography>
                                            }          
                                        </Grid>
                                    </Grid>
                                </CardFrom>                               
                            </Grid>
                            <Grid item sx={{ marginTop: '6%', }}><ArrowForwardIosIcon sx={{ fontSize: '70px', color: '#aaefff' }} /></Grid>
                        </Fragment>
                    }
                    <Grid item xs={12} md={3}>
                        <CardFrom bgColor='#ffe6de' heightCard='222px'>
                            <Grid item xs={12} md={12} sx={{ textAlign: 'center' }}>
                                <PersonIcon sx={{ fontSize: '90px', color: '#cb6f2c' }} />
                                <Grid item>
                                    <Typography gutterBottom variant="h6" component="div">{`${I18n.SetText("Leave.sDirector_Pile")}`}</Typography>
                                    {ObjApprover?.isPile ?
                                        <SelectItem
                                            id={"nApproveID_2"}
                                            name={"nApproveID_2"}
                                            label={`${I18n.SetText("Leave.sNameofApprover")}`}
                                            placeholder={`${I18n.SetText("Leave.sDefaultApprover")}`}
                                            options={ObjApprover?.arrUserApprove_2 ?? []}
                                            required={true}
                                        />     
                                        :
                                        <Typography variant="body2" color="text.secondary" style={{marginTop: '6%',}}>{sApprove_2}</Typography>
                                    }   
                                </Grid>
                            </Grid>
                        </CardFrom>
                    </Grid>       
                </Grid>
            }
        </Grid>
    )
}
export default StepFlow;